var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircleFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  fillRule: "evenodd",
  d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666m0 7.152 2.062-2.062a.833.833 0 0 1 1.426.59.83.83 0 0 1-.245.591L11.18 10l2.099 2.098a.834.834 0 0 1-.59 1.426.83.83 0 0 1-.591-.245L10 11.18l-2.098 2.098a.833.833 0 0 1-1.426-.59c0-.222.088-.435.245-.59L8.82 10 6.76 7.938a.833.833 0 0 1 .59-1.426c.221 0 .434.089.59.245z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircleFilled);
export default ForwardRef;